import { defaultContactEmail } from '../env'
import { SanityTmCheckout } from '../services/sanity/types'
import { Building } from '../types/building'
import { Product } from '../types/product'

/*
  Force url string to avoid URL exception erros
  Check if url is a valid http string
*/
export const isValidHttpURL = (url = '') => {
  try {
    new URL(url.toString())
  } catch (e) {
    return false
  }
  return true
}

/*
  if relative url add base path
  otherwise return url string unchanged
  replace duplicate paths on url string
  TODO: update script to pull base path 'new' dynamically

*/
export const addBasePath = (url = '') => {
  if (url?.startsWith('#')) return url
  if (!isValidHttpURL(url)) return `/${url}`.replace('//', '/')
  else return url
}

/*
  Check if valid url, we should automatically skip relative links
  Check if base url matches (internal site list)
  Return true if no match is found
  TODO: Update Sanity to Control target behaviour
*/
export const isExternalURL = (href: string) => {
  const isValidURL = isValidHttpURL(href)
  const internalSiteList = process.env.STUDIO_INTERNAL_LINKS?.split(',')

  if (!isValidURL) return false

  const baseURL = new URL(href).origin

  if (internalSiteList?.includes(baseURL)) return false
  else return true
}

export const addExternalUrlProtocol = (url?: string) => {
  if (!url) return '#'

  url = url.trim()
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return 'https://' + url
  }
  return url
}

export const extractRegionFromUrl = (href: string) => {
  const parsedUrl = new URL(href)
  const queryParams = new URLSearchParams(parsedUrl.search)
  const region = queryParams.get('region')
  return region
}

export const replaceEmailInConfirmationPage = (
  confirmation: SanityTmCheckout['confirmation'],
  product: Product,
  building?: Building
) => {
  const email = getBuildingContactEmail(product, building)
  if (Array.isArray(confirmation.guestRegistration)) {
    confirmation.guestRegistration.forEach((block) => {
      if (Array.isArray(block.children)) {
        block.children.forEach((span) => {
          if (typeof span.text === 'string') {
            span.text = span.text.replace('{email}', email)
          }
        })
      }
    })
  }
  if (Array.isArray(confirmation.modifyInstructions)) {
    confirmation.modifyInstructions.forEach((block) => {
      if (Array.isArray(block.children)) {
        block.children.forEach((span) => {
          if (typeof span.text === 'string') {
            span.text = span.text.replace('{email}', email)
          }
        })
      }
    })
  }
}

export const getBuildingContactEmail = (product: Product, building?: Building): string => {
  if (product.type === 'event_space') {
    return building?.eventsContactEmail || building?.contactEmail || defaultContactEmail
  }
  return building?.contactEmail || defaultContactEmail
}
